import { apiFetch } from './common';
import { API_ENDPOINTS } from '../config/constants';

export interface NotificationAction {
  type: 'navigate_to' | 'enable_preference' | 'open_external' | 'dismiss';
  label: string;
  path?: string;
  preferenceKey?: string;
  preferenceValue?: string;
  url?: string;
}

export interface NotificationItem {
  id: string;
  category: string;
  type: 'info' | 'warning' | 'error' | 'success';
  title: string;
  message: string;
  actions: NotificationAction[];
  source: 'admin' | 'system';
  showAsModal: boolean;
  isRead: boolean;
  isDismissed: boolean;
  createdAt: string | null;
  expiresAt: string | null;
}

export interface NotificationInboxResponse {
  items: NotificationItem[];
  unreadCount: number;
}

export interface UnreadCountResponse {
  unreadCount: number;
}

export interface LoginAnnouncementResponse {
  announcements: NotificationItem[];
}

export const NotificationsAPI = {
  async getInbox(limit = 50, offset = 0): Promise<NotificationInboxResponse> {
    return apiFetch<NotificationInboxResponse>(
      `${API_ENDPOINTS.NOTIFICATIONS.INBOX}?limit=${limit}&offset=${offset}`,
    );
  },

  async getUnreadCount(): Promise<UnreadCountResponse> {
    return apiFetch<UnreadCountResponse>(API_ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT);
  },

  async getLoginAnnouncements(): Promise<LoginAnnouncementResponse> {
    return apiFetch<LoginAnnouncementResponse>(API_ENDPOINTS.NOTIFICATIONS.LOGIN_ANNOUNCEMENTS);
  },

  async markAllRead(): Promise<void> {
    await apiFetch(API_ENDPOINTS.NOTIFICATIONS.MARK_ALL_READ, { method: 'POST' });
  },

  async markRead(notificationId: string): Promise<void> {
    await apiFetch(`${API_ENDPOINTS.NOTIFICATIONS.INBOX}${notificationId}/read`, {
      method: 'PATCH',
    });
  },

  async dismiss(notificationId: string): Promise<void> {
    await apiFetch(`${API_ENDPOINTS.NOTIFICATIONS.INBOX}${notificationId}/dismiss`, {
      method: 'PATCH',
    });
  },
};
